export default __webpack_public_path__ + "static/media/Capitolo 1.95abb61c.mp3";